// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"styles_bannerWrapper__yLtuA","description":"styles_description__sNjD1","button":"styles_button__v6Vfn"};